import React, { useEffect, useState } from 'react';
import {
    FaTh,
    FaBars,
    FaTimes,
    FaChevronLeft,
    FaChevronRight,
} from "react-icons/fa";
import { GrTransaction, GrUpdate } from "react-icons/gr";
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import { useTranslation } from "react-i18next";
import { TbLogout, TbBookUpload } from "react-icons/tb";
import { signOut } from "firebase/auth";
import { auth } from '../firbase.config';
import { useDispatch, useSelector } from 'react-redux';
import { loginUserData, savePhone, getUserPhone } from '../redux/loginSlice';
import { getDatabase, ref, onValue } from "firebase/database";
import './DashBar.css';

const AdminSidebar = ({ children }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const db = getDatabase();
    const { t } = useTranslation();
    const count = useSelector(getUserPhone);
    const [isAdmin, setisAdmin] = useState(false);
    const [userRole, setUserRole] = useState('');

    // Responsive and collapsible states
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isMobileOpen, setIsMobileOpen] = useState(false);

    useEffect(() => {
        const starCountRef = ref(db, 'Users/' + count + '/data/');
        onValue(starCountRef, (snapshot) => {
            const data1 = snapshot.val();
            if (snapshot.exists()) {
                setUserRole(data1.role || '');
                if (data1.role === "admin") {
                    setisAdmin(true);
                } else {
                    setisAdmin(false);
                }
            }
        });
    }, [count, db]);

    // Close mobile drawer when route changes
    useEffect(() => {
        setIsMobileOpen(false);
    }, [location.pathname]);

    // Prevent body scrolling when mobile drawer is open & handle Escape key
    useEffect(() => {
        if (isMobileOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                setIsMobileOpen(false);
            }
        };

        const handleResize = () => {
            if (window.innerWidth > 768) {
                setIsMobileOpen(false);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('resize', handleResize);

        return () => {
            document.body.style.overflow = '';
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('resize', handleResize);
        };
    }, [isMobileOpen]);

    const menuItem = [
        {
            path: "/dash",
            name: t('Home'),
            icon: <FaTh />,
            isAdmin: true
        },
        {
            path: "/Adtransactions",
            name: t('Transactions'),
            icon: <GrTransaction />,
            isAdmin: true
        },
        {
            path: "/updates",
            name: "Updates",
            icon: <GrUpdate />,
            isAdmin: isAdmin
        },
        {
            path: "/customerBooking",
            name: "CustomerBooking",
            icon: <TbBookUpload />,
            isAdmin: true
        },
    ];

    const Logout = () => {
        signOut(auth).then(() => {
            localStorage.removeItem('userToken');
            localStorage.removeItem('userPhone');
            dispatch(loginUserData(null));
            dispatch(savePhone(null));
            navigate('/login', { replace: true });
        }).catch((error) => {
            // An error happened.
        });
    };

    return (
        <div className={`admin-layout ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
            {/* Top Header for Mobile screens (<= 768px) */}
            <header className="admin-mobile-header">
                <div className="admin-mobile-left">
                    <button
                        type="button"
                        className="admin-hamburger-btn"
                        onClick={() => setIsMobileOpen((prev) => !prev)}
                        aria-label="Toggle navigation menu"
                    >
                        <FaBars />
                    </button>
                    <div className="admin-mobile-brand">
                        <img src={logo} alt={t('GMB_Complex')} className="admin-mobile-logo" />
                        <span className="admin-mobile-title" title={t('GMB_Complex')}>
                            {t('GMB_Complex')}
                        </span>
                    </div>
                </div>
                <span className="admin-mobile-role-badge">
                    {userRole === 'admin' ? 'Admin' : userRole || 'Dashboard'}
                </span>
            </header>

            {/* Backdrop overlay for mobile drawer */}
            <div
                className={`admin-sidebar-backdrop ${isMobileOpen ? 'active' : ''}`}
                onClick={() => setIsMobileOpen(false)}
                aria-hidden="true"
            />

            {/* Sidebar (collapsible on desktop, off-canvas drawer on mobile) */}
            <aside
                className={`admin-sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}
                aria-label="Admin Navigation"
            >
                {/* Sidebar Header */}
                <div className="admin-sidebar-header">
                    <div className="admin-sidebar-brand">
                        <img src={logo} alt={t('GMB_Complex')} className="admin-sidebar-logo" />
                        <div className="admin-sidebar-brand-text">
                            <h2 className="admin-sidebar-title" title={t('GMB_Complex')}>
                                {t('GMB_Complex')}
                            </h2>
                            <span className="admin-sidebar-subtitle">
                                {userRole === 'admin' ? 'Admin Panel' : 'Dashboard'}
                            </span>
                        </div>
                    </div>

                    {/* Desktop Collapse / Expand Toggle */}
                    <button
                        type="button"
                        className="admin-collapse-btn"
                        onClick={() => setIsCollapsed((prev) => !prev)}
                        title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
                        aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
                    >
                        {isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
                    </button>

                    {/* Mobile Close Button */}
                    <button
                        type="button"
                        className="admin-sidebar-close-btn"
                        onClick={() => setIsMobileOpen(false)}
                        aria-label="Close sidebar"
                    >
                        <FaTimes />
                    </button>
                </div>

                {/* Sidebar Navigation */}
                <nav className="admin-sidebar-nav">
                    <div className="admin-nav-category">
                        {isCollapsed ? '•••' : 'Navigation'}
                    </div>

                    {menuItem.map((item, index) => (
                        item.isAdmin && (
                            <NavLink
                                to={item.path}
                                key={index}
                                className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
                                onClick={() => setIsMobileOpen(false)}
                                title={item.name}
                            >
                                <span className="admin-nav-icon">{item.icon}</span>
                                <span className="admin-nav-label">{item.name}</span>
                            </NavLink>
                        )
                    ))}
                </nav>

                {/* Sidebar Footer with Logout */}
                <div className="admin-sidebar-footer">
                    <button
                        type="button"
                        className="admin-nav-link admin-logout-btn"
                        onClick={() => {
                            setIsMobileOpen(false);
                            Logout();
                        }}
                        title="Logout"
                    >
                        <span className="admin-nav-icon"><TbLogout /></span>
                        <span className="admin-nav-label">Logout</span>
                    </button>
                </div>
            </aside>

            {/* Main Content Area */}
            <main className="admin-main-content">
                {children}
            </main>
        </div>
    );
};

export default AdminSidebar;